import { render, staticRenderFns } from "./purchase-batch-reminder-modal.vue?vue&type=template&id=4d383d9c"
import script from "./purchase-batch-reminder-modal.ts?vue&type=script&lang=js&external"
export * from "./purchase-batch-reminder-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports